import axios from "axios";

export async function sendInvitationEmail(data) {
  const BASE_API = process.env.REACT_APP_BASE_API;
  try {
    const res = await axios.post(`${BASE_API}auth/invitation-email`, data);
    return res;
  } catch (error) {
    console.log("err", error);
  }
}
